import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import {
  UsersIcon,
  TagIcon,
  StarIcon,
  BellAlertIcon,
  ChatBubbleLeftRightIcon,
  FunnelIcon,
  HashtagIcon,
  KeyIcon,
  FlagIcon,
  CheckCircleIcon,
  BarsArrowUpIcon,
  PaperClipIcon,
  LockClosedIcon,
  ClockIcon,
  UserGroupIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
  ListBulletIcon,
  BanknotesIcon,
  CreditCardIcon,
  ExclamationCircleIcon,
  EnvelopeIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import LandingNav from '../components/landing/LandingNav';
import HeroSection from '../components/landing/HeroSection';
import PlatformOverview from '../components/landing/PlatformOverview';
import FeatureSection from '../components/landing/FeatureSection';
import CollaborationSection from '../components/landing/CollaborationSection';
import ClosingSection from '../components/landing/ClosingSection';

const CLIENT_CHIPS = [
  { id: 'contacts', icon: UsersIcon },
  { id: 'statuses', icon: TagIcon },
  { id: 'scores', icon: StarIcon },
  { id: 'followUps', icon: BellAlertIcon },
  { id: 'interactions', icon: ChatBubbleLeftRightIcon },
  { id: 'sources', icon: FunnelIcon },
  { id: 'tags', icon: HashtagIcon },
  { id: 'accounts', icon: KeyIcon }
];

const PROJECT_CHIPS = [
  { id: 'milestones', icon: FlagIcon },
  { id: 'tasks', icon: CheckCircleIcon },
  { id: 'priorities', icon: BarsArrowUpIcon },
  { id: 'files', icon: PaperClipIcon },
  { id: 'notes', icon: LockClosedIcon },
  { id: 'timeline', icon: ClockIcon },
  { id: 'roles', icon: UserGroupIcon },
  { id: 'permissions', icon: ShieldCheckIcon }
];

const FINANCE_CHIPS = [
  { id: 'invoices', icon: DocumentTextIcon },
  { id: 'lineItems', icon: ListBulletIcon },
  { id: 'payments', icon: BanknotesIcon },
  { id: 'methods', icon: CreditCardIcon },
  { id: 'overdue', icon: ExclamationCircleIcon },
  { id: 'email', icon: EnvelopeIcon },
  { id: 'reports', icon: ChartBarIcon }
];

export default function Landing() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet defer={false}>
        <title>{t('landing.meta.title')}</title>
        <meta name="description" content={t('landing.meta.description')} />
        <meta property="og:title" content={t('landing.meta.title')} />
        <meta property="og:description" content={t('landing.meta.description')} />
      </Helmet>

      <div className="lp min-h-screen">
        <a
          href="#main"
          className="lp-focus sr-only z-[60] rounded-md bg-ink px-4 py-2 text-sm text-white focus:not-sr-only focus:fixed focus:start-4 focus:top-4"
        >
          {t('landing.nav.skip')}
        </a>
        <LandingNav />
        <main id="main">
          <HeroSection />
          <PlatformOverview />
          <FeatureSection id="clients" canvas="clients" image="feature-crm" chips={CLIENT_CHIPS} />
          <FeatureSection
            id="projects"
            canvas="projects"
            image="feature-projects"
            overlay="overlay-team"
            chips={PROJECT_CHIPS}
          />
          <FeatureSection id="finance" canvas="finance" image="feature-finance" chips={FINANCE_CHIPS} />
          <CollaborationSection />
        </main>
        <ClosingSection />
      </div>
    </>
  );
}
